'use strict';
{
    var app = angular.module('tf.distStrategy', [])
        .controller('distStrategyCtrl', ['$scope', '$stateParams', 'linkedWhatIfs', '$localStorage', '$state', 'distributedStrategy', function istStrategyController($scope, $stateParams, linkedWhatIfs, $localStorage, $state, distributedStrategy) {

            $scope.Math = Math;
            $scope.distributedStrategy = distributedStrategy;
            $scope.distributedStrategy.trades.forEach(function(t){
                if (t.quantity >= 0) {
                    t.side = "B"
                } else {
                    t.side = "S"
                }
            });
            $scope.linkedWhatIfs = linkedWhatIfs;
            $scope.linkedWhatIfs.forEach(function(w){
                w.trades.forEach(function(t){
                    if (t.quantity >= 0) {
                        t.side = "B"
                    } else {
                        t.side = "S"
                    }
                })
            });

            $scope.gridsterOpts2 = {
                columns: 3, // the width of the grid, in columns
                pushing: true, // whether to push other items out of the way on move or resize
                floating: false, // whether to automatically float items up so they stack (you can temporarily disable if you are adding unsorted items with ng-repeat)
                swapping: false, // whether or not to have items of the same size switch places instead of pushing down if they are the same size
                width: 'auto', // can be an integer or 'auto'. 'auto' scales gridster to be the full width of its containing element
                colWidth: 'auto', // can be an integer or 'auto'.  'auto' uses the pixel width of the element divided by 'columns'
                rowHeight: '220', // can be an integer or 'match'.  Match uses the colWidth, giving you square widgets.
                margins: [10, 10], // the pixel distance between each widget
                outerMargin: true, // whether margins apply to outer edges of the grid
                isMobile: false, // stacks the grid items if true
                mobileBreakPoint: 600, // if the screen is not wider that this, remove the grid layout and stack the items
                mobileModeEnabled: true, // whether or not to toggle mobile mode when screen width is less than mobileBreakPoint
                minColumns: 1, // the minimum columns the grid must have
                minRows: 1, // the minimum height of the grid, in rows
                maxRows: 100,
                defaultSizeX: 1, // the default width of a gridster item, if not specifed
                defaultSizeY: 1, // the default height of a gridster item, if not specified
                minSizeX: 1, // minimum column width of an item
                maxSizeX: null, // maximum column width of an item
                minSizeY: 1, // minumum row height of an item
                maxSizeY: null, // maximum row height of an item
                resizable: {
                    enabled: false,
                    handles: [ 's']
                    //start: function(event, $element, widget) {}, // optional callback fired when resize is started,
                    //resize: function(event, $element, widget) {
                },
                draggable: {
                    enabled: false, // whether dragging items is supported
                    handle: '.draggableHandle' // optional selector for drag handle
                    //                  start: function(event, $element, widget) {}, // optional callback fired when drag is started,
                    //                drag: function(event, $element, widget) {}, // optional callback fired when item is moved,
                    //              stop: function(event, $element, widget) {} // optional callback fired when item is finished dragging
                }
            };

            $scope.goToWhatIf = function(whatIf) {
                $localStorage['portfolioPrefs_' + whatIf.portfolioId].selectedTab = 'WhatIf';
                $localStorage['portfolioPrefs_' + whatIf.portfolioId].activeWhatIf = whatIf.id;
                $state.go('portfolio', {portfolioId: whatIf.portfolioId});
            };

            $scope.editStrategy = function() {
                    $state.go('adviserLists', {strategyId : $scope.distributedStrategy.id});
            }

        }]);
}






